import React from 'react';
import useSortableTable from './useSortableTable';
import './SortableTable.css';
import { calculateMarketValue, formatCurrency, getRowKey } from './helpers';

function ETFTable({ etfs, onDelete, onEdit, onUpdate, editQuantity, setEditQuantity, editingPosition }) {
  const columns = ['position', 'quantity', 'price'];
  const { sortedData, requestSort, getSortClass } = useSortableTable(etfs, columns);

  return (
    <div>
      <h2>ETFs</h2>
      <div className="table-responsive-wrapper">
      <table>
        <thead>
          <tr>
            <th>Ticker</th>
            <th onClick={() => requestSort('quantity')} className={getSortClass('quantity')}>Quantity</th>
            <th onClick={() => requestSort('price')} className={getSortClass('price')}>Price</th>
            <th onClick={() => requestSort('marketValue')} className={getSortClass('marketValue')}>Market Value</th>
	    <th>Actions</th>
	  </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr key={index}>
              <td>{item.position}</td>
              <td>{item.quantity}</td>
	      <td>{formatCurrency(item.details?.Price) || '-'}</td>
              <td>{formatCurrency(calculateMarketValue(item.quantity, item.details?.Price))}</td>
	      <td>
                <button onClick={() => onDelete(item)}>Delete</button>
                {editingPosition === getRowKey(item) ? (
                  <div>
                    <input
                      type="number"
                      value={editQuantity}
                      onChange={(e) => setEditQuantity(e.target.value)}
                    />
                    <button onClick={() => onUpdate(item)}>Save</button>
                    <button onClick={() => onEdit(null)}>Cancel</button>
                  </div>
                ) : (
			 <button onClick={() => {
    onEdit(getRowKey(item));
    setEditQuantity(item.quantity);
  }}>Edit</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default ETFTable;
